import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import IndexPage from 'pages/IndexPage/IndexPage';
import SubdirectoryPage from 'pages/SubdirectoryPage/SubdirectoryPage';
import SearchResultsPage from 'pages/SearchResultsPage/SearchResultsPage';
import AccessDeniedPage from 'pages/AccessDeniedPage/AccessDeniedPage';
import ErrorPage from 'pages/ErrorPage/ErrorPage';
import CreateCategoryPage from 'pages/CreateCategoryPage/CreateCategoryPage';
import EditCategoryPage from 'pages/EditCategoryPage/EditCategoryPage';
import DeleteCategoryPage from 'pages/DeleteCategoryPage/DeleteCategoryPage';
import CreateResourcePage from 'pages/CreateResourcePage/CreateResourcePage';
import EditResourcePage from 'pages/EditResourcePage/EditResourcePage';
import { libraryViewLoader, indexPageLoader } from './routeLoaders';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/VirtualLibrary" replace />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/VirtualLibrary',
    element: <IndexPage />,
    errorElement: <ErrorPage />,
    loader: indexPageLoader,
  },
  {
    path: '/VirtualLibrary/browse',
    element: <SubdirectoryPage />,
    errorElement: <ErrorPage />,
    loader: libraryViewLoader,
  },
  {
    path: '/VirtualLibrary/search',
    element: <SearchResultsPage />,
    errorElement: <ErrorPage />,
    loader: libraryViewLoader,
  },
  {
    path: '/VirtualLibrary/category/create',
    element: <CreateCategoryPage />,
    errorElement: <ErrorPage />,
    loader: libraryViewLoader,
  },
  {
    path: '/VirtualLibrary/category/edit',
    element: <EditCategoryPage />,
    errorElement: <ErrorPage />,
    loader: libraryViewLoader,
  },
  {
    path: '/VirtualLibrary/category/delete',
    element: <DeleteCategoryPage />,
    errorElement: <ErrorPage />,
    loader: libraryViewLoader,
  },
  {
    path: '/VirtualLibrary/resource/create',
    element: <CreateResourcePage />,
    errorElement: <ErrorPage />,
    loader: libraryViewLoader,
  },
  {
    path: '/VirtualLibrary/resource/edit/:id',
    element: <EditResourcePage />,
    errorElement: <ErrorPage />,
    loader: libraryViewLoader,
  },
  {
    path: '/VirtualLibrary/access-denied',
    element: <AccessDeniedPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '*',
    element: <ErrorPage />,
  },
]);

export default router;
